import { createIcon } from '@chakra-ui/react';

export const DeleteIcon = createIcon({
  displayName: 'DeleteIcon',
  path: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M12.25 3.48698C10.3075 3.29448 8.35333 3.19531 6.405 3.19531C5.25 3.19531 4.095 3.25365 2.94 3.37031L1.75 3.48698"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.95898 2.90047L5.08732 2.1363C5.18065 1.58214 5.25065 1.16797 6.23648 1.16797H7.76482C8.75065 1.16797 8.82648 1.60547 8.91398 2.14214L9.04232 2.90047"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9956 5.33203L10.6164 11.2062C10.5522 12.122 10.4997 12.8337 8.87224 12.8337H5.12724C3.49974 12.8337 3.44724 12.122 3.38307 11.2062L3.00391 5.33203"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.02539 9.625H7.96789"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.54102 7.29297H8.45768"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
  ),
});
